import { LegalLayout } from './LegalLayout';

export const SupportPage = () => (
  <LegalLayout title="Suporte" updated="14 de maio de 2026">
    <p>
      A gente responde rápido. Escolhe o canal mais conveniente.
    </p>

    <h2>Canais de contato</h2>
    <ul>
      <li>
        <strong>Email:</strong>{' '}
        <a href="mailto:contato@portico.studio">contato@portico.studio</a> — resposta em até 24h
        úteis.
      </li>
      <li>
        <strong>WhatsApp:</strong>{' '}
        <a href="https://wa.me/5511940373492" target="_blank" rel="noreferrer">
          +55 11 94037-3492
        </a>{' '}
        — atendimento humano de segunda a sexta, 9h às 19h (BRT).
      </li>
    </ul>

    <h2>Perguntas frequentes</h2>

    <h3>O render saiu diferente do que eu queria. Posso refazer?</h3>
    <p>
      Pode. Toda vez que você manda um render, gastamos 1 ou mais créditos conforme o tier. Se o
      resultado não atendeu, você pode regerar com parâmetros diferentes (cena, hora do dia,
      estilo, descrição). Se o render falhou por erro técnico do nosso lado, o crédito é estornado
      automaticamente.
    </p>

    <h3>Meu crédito não foi estornado depois de uma falha.</h3>
    <p>
      Manda o ID do render (aparece em "Meus renders") por email pra{' '}
      <a href="mailto:contato@portico.studio">contato@portico.studio</a>. A gente estorna manualmente.
    </p>

    <h3>Como cancelo minha assinatura?</h3>
    <p>
      Você cancela direto no painel do Asaas — eles enviam o link junto da primeira cobrança.
      Cancelamento em 1 clique, sem fidelidade. Se não achar, escreve pra suporte que a gente
      cancela.
    </p>

    <h3>Por que algumas imagens demoram mais que outras?</h3>
    <p>
      O tier escolhido define o tempo. Draft é rápido (~20s). Standard fica em torno de 35-40s.
      Premium e Variants podem chegar a 1 minuto. Em horários de pico (fim de tarde no Brasil)
      pode haver fila de poucos segundos.
    </p>

    <h3>Os renders aceitam SketchUp, Revit e fotos de obra?</h3>
    <p>
      A gente aceita imagens JPG, PNG ou WebP até 50MB. Pode ser um screenshot do seu SketchUp/Revit,
      uma planta digitalizada, um sketch a mão ou foto de uma obra vazia. Quanto mais clara a
      composição, melhor o resultado.
    </p>

    <h3>Posso usar os renders comercialmente?</h3>
    <p>
      Sim. Detalhes em <a href="/licenca-de-imagem">Licença de Imagem</a>.
    </p>

    <h3>Vocês treinaram a IA com meu modelo?</h3>
    <p>
      Não. Modelos enviados ficam isolados na sua conta e não alimentam treinamento de IA. Detalhes
      em <a href="/privacidade">Política de Privacidade</a>.
    </p>

    <h3>Quero faturar como pessoa jurídica.</h3>
    <p>
      Os planos pagos no Asaas já emitem NFS-e automática. Pode usar email comercial no cadastro e
      CNPJ na configuração da cobrança no Asaas. Pra contratos de volume customizado ou
      pré-pagamento empresarial, escreve pra{' '}
      <a href="mailto:contato@portico.studio">contato@portico.studio</a>.
    </p>
  </LegalLayout>
);
